/**
 * harmony-hero.js — homepage hero hooks.
 *
 * [data-h-hero-note-close] dismisses the floating "Une note de Clément" card
 * ([data-h-hero-note]) — delegated at document scope so it works regardless of
 * when the section renders.
 */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-h-hero-note-close]');
  if (!trigger) return;
  const card = trigger.closest('[data-h-hero-note]');
  if (card) card.remove();
});
